import { render, staticRenderFns } from "./tbmMac.vue?vue&type=template&id=20d18a87&scoped=true&"
import script from "./tbmMac.vue?vue&type=script&lang=js&"
export * from "./tbmMac.vue?vue&type=script&lang=js&"
import style0 from "./tbmMac.vue?vue&type=style&index=0&id=20d18a87&scoped=true&lang=css&"
import style1 from "./tbmMac.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d18a87",
  null
  
)

export default component.exports